import { DynamicService } from 'utils/service';

import {
  API_USER_PATIENT_PROFILE_SESSIONS_SENSITIVITY_DRUGS,
  CreateBulkUserPatientProfileSessionSensitivityDrugInput,
  UserPatientProfileSessionSensitivityDrug,
} from './models';

export * from './models';

class Service extends DynamicService<UserPatientProfileSessionSensitivityDrug> {
  createBulk = async (input: CreateBulkUserPatientProfileSessionSensitivityDrugInput) => {
    return this.engine.post(API_USER_PATIENT_PROFILE_SESSIONS_SENSITIVITY_DRUGS.POST_BULK, {
      mainID: input.userPatientProfileSessionID,
      itemIDs: input.sensitivityDrugIDs,
    });
  };
}

export const ServiceUserPatientProfileSessionsSensitivityDrugs = new Service({
  mainField: 'id',
  getAll: API_USER_PATIENT_PROFILE_SESSIONS_SENSITIVITY_DRUGS.GET_ALL_DYNAMIC,
  post: API_USER_PATIENT_PROFILE_SESSIONS_SENSITIVITY_DRUGS.POST,
  delete: API_USER_PATIENT_PROFILE_SESSIONS_SENSITIVITY_DRUGS.DELETE,
  patch: API_USER_PATIENT_PROFILE_SESSIONS_SENSITIVITY_DRUGS.PATCH,
});
